import React from 'react';

export const NotFound = () => (
  <div className="row text-center">
    <div className="col-lg-12">
      <h1 className="msg-h1">404 - Page Not Found!</h1>
    </div>
  </div>
);